import React from 'react'
import FishboneChart from './components/fishbone/fishboneChart'
export default FishboneChart